export default "__VITE_ASSET__JxvMGsCT__"